import { m } from "framer-motion";
import { useState } from "react";
import companies from "../data/companies";
import CompanyCard from "../components/CompanyCard";
import CompanyModal from "../components/CompanyModal";
import ReactGA from 'react-ga4';

const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.25 }
};

export default function Companies() {
  const [selected, setSelected] = useState(null);

  const onCardKeyDown = (e, c) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick(c);
    }
  };

  const handleCardClick = (company) => {
    setSelected(company);
    ReactGA.event({
      category: "Company Interaction",
      action: "Open Modal",
      label: company.name,
    });
  };

  return (
    <m.section {...fade} className="relative overflow-hidden">
      {/* page background (flag): AVIF when supported, low priority so first card can be LCP */}
      <div className="fixed inset-0 -z-10 pointer-events-none">
        <picture>
          <source srcSet="/images/bg-flag-diagnal.avif" type="image/avif" />
          <img
            src="/images/bg-flag-diagnal.jpg"
            alt="American flag background"
            fetchPriority="low"
            loading="lazy"
            className="w-full h-full object-cover opacity-[0.12] md:opacity-[0.10] brightness-90 saturate-110 contrast-105"
            style={{ objectPosition: "center center", scale: "1.0" }}
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/40" />
      </div>

      <h1 className="font-['Cinzel'] text-4xl sm:text-5xl font-extrabold leading-tight text-gray-900 text-center mb-8">Companies</h1>

      <div className="grid gap-8 sm:gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-1">
        {companies.map((c, i) => (
          <m.div
            key={c.slug}
            role="button"
            tabIndex={0}
            className="group cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500/40 rounded-xl transition-all duration-300 hover:-translate-y-2 h-96 flex flex-col"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, delay: i * 0.1 }}
            onClick={() => handleCardClick(c)}
            onKeyDown={(e) => onCardKeyDown(e, c)}
          >
            <CompanyCard {...c} priority={i === 0} onSeeMore={() => handleCardClick(c)} />
          </m.div>
        ))}
      </div>

      {/* Modular modal — only in DOM when open */}
      {selected && (
        <CompanyModal
          company={selected}
          open
          onClose={() => setSelected(null)}
        />
      )}
    </m.section>
  );
}
